import { MockBackend } from '@angular/http/testing';
import { Response, ResponseOptions } from '@angular/http';
import { Injectable } from '@angular/core';

@Injectable()
export class TranslationMock {
  private translations;
  private localeFromUrl: string;
  private matchArray: string[];

  constructor(private backend: MockBackend) {
    this.initializeMocks();
  }

  initializeMocks() {
    this.backend.connections.subscribe( req => {

      let anyLocaleUrlRegExp = /assets\/i18n\/app\/(.*).json/i;
      // Match the pattern within (.*) which comes as the
      // second array element. Output is an array like ["assets/i18n/fr.json", "fr"]
      this.matchArray = req.request.url.toString().match(anyLocaleUrlRegExp);

      // GET assets/i18n/*.json
      if (this.matchArray && this.matchArray.length > 0 && req.request.method === 0) {
        this.localeFromUrl = (this.matchArray.length > 1 &&
          typeof this.matchArray[1] === 'string'
            && this.matchArray[1].length) ? this.matchArray[1] : 'en';
        this.translations = require('../assets/i18n/app/' + this.localeFromUrl + '.json');
        req.mockRespond(new Response(new ResponseOptions({
          body: JSON.stringify( this.translations )
        })));
      }

    });
  }
}



// WEBPACK FOOTER //
// ./src/app/translation.mock.ts